const CLOCK_START_CS = 2600
const CLOCK_END_CS = 1500
const REVEAL_MS = [1200, 3450, 5100]

export const TEST_DRIVE_PLAYBACK_MS = (CLOCK_START_CS - CLOCK_END_CS) * 10

function pad(value) {
  return String(value).padStart(2, "0")
}

export function formatTestDriveClock(centiseconds) {
  const clamped = Math.max(0, centiseconds)
  const cs = clamped % 100
  const seconds = Math.floor(clamped / 100)
  const ss = seconds % 60
  const mm = Math.floor(seconds / 60)
  return `${pad(mm)}:${pad(ss)}.${pad(cs)}`
}

export function testDrivePlaybackFrame(elapsedMs) {
  const elapsed = Math.max(0, elapsedMs)
  const spentCs = Math.min(CLOCK_START_CS - CLOCK_END_CS, Math.floor(elapsed / 10))
  const clock = formatTestDriveClock(CLOCK_START_CS - spentCs)
  let visibleCount = 0
  for (const mark of REVEAL_MS) {
    if (elapsed >= mark) visibleCount += 1
  }
  return { clock, visibleCount, showFinal: elapsed >= TEST_DRIVE_PLAYBACK_MS }
}

export function withSubmittedPhone(event, phone) {
  if (!phone) return event
  return event.replace(/\[[^[\]]+\](?=\.\.\.$)/, () => phone)
}
